import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { CardBox, hideScrollbar } from "../../lib/styles/styleLibrary";
import { Avatar, Button, Image, Progress } from "antd";

import MainLayout from "../../components/MainLayout/MainLayout";
import wallet from "../../assets/svg/wallet.svg";
import vendorImg from "../../assets/images/vendor.png";
import bell from "../../assets/svg/bellAlertTrans.svg";
import plus from "../../assets/svg/plus.svg";
import caret from "../../assets/svg/caret.svg";
import time from "../../assets/svg/time.svg";
import camera from "../../assets/svg/solids/camera.png";
import girl from "../../assets/svg/girl.png";
import diary from "../../assets/svg/solids/diary.png";
import invitation from "../../assets/svg/solids/invitation.png";
import calendar from "../../assets/svg/solids/calendar.png";
import gift from "../../assets/svg/solids/gift.png";
import vendor from "../../assets/svg/solids/vendor.png";
import love from "../../assets/images/love.png";
import { COLORS } from "../../lib/styles/styles";
import {
	EmptyData,
	Loading,
	SplitPane,
	TimelineComp,
	SetupWallet,
	SearchComponent,
} from "../../components";
import { isEmpty } from "../../lib/helpers/helpers";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { ROUTES } from "../../settings/routes";
import Auth from "../../lib/middleware/auth";
import { useMediaQuery } from "react-responsive";
import {
	HomeTimelineWrapper,
	HomeWrapper,
	UpcomingWeddingContainer,
} from "./component";
import { useTimeline } from "../../redux/api/Timeline";
import { useGuestList } from "../../redux/api/Registry";
import { TimelineContainer } from "../Timeline/component";
import {
	useCouplesData,
	useUserProfileData,
	useFetchUpcomingWeddings,
} from "../../redux/api/WeddingAPI";
import PinSetup from "../../components/SetupWallet/PinSetup";
import PinInput from "../../components/PinInput/PinInput";
import TimelineSkeleton from "../../components/TimelineSharedComponents/TimelineSkeleton";
import WeddingCard from "../../components/WeddingCard/WeddingCard";
import { NoUpcomingWedding, VendorAdvertCard } from "../Vendors/component";
import { v4 } from "uuid";
// import WeddingAlbumCard from "../../components/WeddingCard/WeddingAlbumCard";

const Home = (props) => {
	var relativeTime = require("dayjs/plugin/relativeTime");
	dayjs.extend(relativeTime);
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const user = Auth.getUser();
	const isLargeScreen = useMediaQuery({ minWidth: 1220 });
	const experience = Auth.getExperience();
	const history = useHistory();
	const coupleLocal = Auth.getCouple();
	const { data: userDt } = useUserProfileData();
	const { data: invites, isLoading: invitesLoading } = useGuestList();
	const { data: coupleData } = useCouplesData();
	const { data: upcomingWeddings, isLoading: upcomingLoading } =
	useFetchUpcomingWeddings();
	const wedding_invites = invites?.data?.data?.wedding_invites;
	const xp = userDt?.current_experience;

	useEffect(() => {}, [xp, experience]);

	const page = 12;
	const {
		data: timeline,
		isLoading: tlLoading,
		refetch: refetchTl,
	} = useTimeline({ page });

	const couple = coupleData?.data || coupleLocal;

	const wedDate =
		experience === "couple"
			? couple?.date
			: upcomingWeddings?.weddings[0]?.date;

	const createDate =
		experience === "couple"
			? couple?.createdAt
			: upcomingWeddings?.weddings[0]?.createdAt;

	const remainingDays = dayjs(wedDate).diff(dayjs(), "day");
	const totalDays = dayjs(wedDate).diff(createDate, "day");
	const progressPercent = ((totalDays - remainingDays) / totalDays) * 100;
	const [isTransactionPin, setTransactionPin] = useState(false);
	const [pin, setUserPin] = useState("");
	const handleRoute = () => {
		!user?.is_wallet_set
			? setTransactionPin(true)
			: history.push(ROUTES.WALLET);
	};

	return (
		<MainLayout>
			<SplitPane
				wrapDirection={"column"}
				hideRightSide={isMobile ? true : false}
				rightHeightAdjust={"5.5rem"}
				left={
					<HomeWrapper css={hideScrollbar}>
						{/* Main Section */}
						<div className="main">
							{/* Banner Layout  */}
							<div className="banner">
								<div tw="pt-4 flex flex-col items-center sm:items-start justify-center sm:justify-start flex-1 flex-nowrap mr-2">
									<span tw="text-sm md:text-base font-medium opacity-50 text-center sm:text-left">
										Hello{" "}
										{!isEmpty(user) &&
										experience !== "couple"
											? `${user?.firstname} 🤗`
											: "lovies ❤️"}
									</span>
									<p tw="font-bold text-2xl  text-center sm:text-left">
										{experience === "couple"
											? !isEmpty(user) &&
											  !isEmpty(couple) &&
											  `${couple?.groom_firstname} &
												${couple?.bride_firstname}`
											: !isEmpty(user) &&
											  `${user?.firstname} ${user?.lastname}`}
									</p>
								</div>
								<div tw="inline-flex items-center justify-center md:justify-end  flex-1">
									<span
										onClick={handleRoute}
										tw="text-sm font-semibold px-3 py-2 inline-flex items-center hover:hover:(text-current shadow-md rounded-2xl cursor-pointer)"
										className="fadedBg">
										<Image
											preview={false}
											src={wallet}
											alt=""
											width={15}
											height={13}
										/>
										<span tw="ml-1">Wallet</span>
									</span>

									<Link to={ROUTES.NOTIFICATIONS}>
										<span tw="text-sm font-semibold inline-flex items-center ml-2 hover:cursor-pointer">
											<Image
												preview={false}
												src={bell}
												alt=""
												width={40}
												height={40}
											/>
										</span>
									</Link>
								</div>
							</div>

							{/* Couples search  */}
							<SearchComponent />

							{/* Upcoming Wedding */}
							{experience === "guest" && (
								<div className="" tw="p-3 md:p-6 ">
									<span className="pre-header">For you</span>
									<div tw="flex flex-row flex-nowrap items-center justify-between pb-2">
										<h2 tw="opacity-80 m-0 text-sm md:text-base">
											Upcoming Weddings
										</h2>
										{/* <Link to={ROUTES.OURSTORY}>
											<span tw="text-appPink opacity-50 text-xs md:text-sm cursor-pointer hover:(text-appPink opacity-100)">
												See All{" "}
												<Image
													preview={false}
													src={caret}
													alt=""
													width={10}
													height={10}
												/>
											</span>
										</Link> */}
									</div>

									<UpcomingWeddingContainer
										css={hideScrollbar}>
										{upcomingLoading ? (
											<div tw="h-full w-full flex items-center justify-center p-8">
												<Loading />
											</div>
										) : isEmpty(
												upcomingWeddings?.weddings
										  ) ? (
											<NoUpcomingWedding tw="flex flex-row items-center! justify-center! px-2 py-4">
												<div tw="flex flex-col gap-1 w-full!  h-full p-5">
													<h2 tw="sm:text-base text-2xl! opacity-50">
														Find a wedding to <br />
														attend
													</h2>
													<p tw="">
														You have no upcomming
														<br />
														weddings yet.
													</p>
												</div>
												<div tw="px-4 py-2 flex flex-row items-center justify-center w-full h-full">
													<Image
														src={love}
														alt=""
														preview={false}
														width="160px"
														height="160px"
														tw="rounded-full bg-gray-100 shadow-sm"
													/>
												</div>
											</NoUpcomingWedding>
										) : (
											upcomingWeddings?.weddings?.map(
												(wedding, i) => {
													return (
														<WeddingCard
															key={i}
															background={
																wedding?.story_cover_image_url
															}
															WeddingData={
																wedding
															}
															date={wedding.date}
															name={`${wedding.bride_firstname} ${wedding.groom_firstname}`}
															location={
																wedding.venue
															}
															details={wedding}
														/>
														// <WeddingAlbumCard
														// 	background={
														// 		wedding?.story_cover_image_url
														// 	}
														// 	WeddingData={
														// 		wedding
														// 	}
														// 	date={wedding.date}
														// 	name={`${wedding.bride_firstname} ${wedding.groom_firstname}`}
														// 	location={
														// 		wedding.venue
														// 	}
														// 	details={wedding}
														// />
													);
												}
											)
										)}
									</UpcomingWeddingContainer>
								</div>
							)}

							{/* Scroll start */}
							<div
								style={{
									height:
										!user?.is_bvn_set &&
										!user?.is_wallet_set
											? isLargeScreen
												? "65%"
												: "55%"
											: "auto",
								}}
								css={hideScrollbar}
								tw="overflow-y-scroll">
								{/* Tell your story  */}
								{experience === "couple" && (
									<div
										className="tell-story"
										tw="bg-white p-3 md:p-6 shadow">
										<span className="pre-header">
											To start with
										</span>
										<div tw="flex flex-row flex-nowrap items-center justify-between pb-2">
											<h2 tw="opacity-80 m-0 text-sm md:text-lg">
												Tell your wedding story
											</h2>
											<Link to={ROUTES.OURSTORY}>
												<span tw="text-appPink opacity-50 text-xs md:text-sm cursor-pointer hover:(text-appPink opacity-100)">
													See All{" "}
													<Image
														preview={false}
														src={caret}
														alt=""
														width={10}
														height={10}
													/>
												</span>
											</Link>
										</div>
										<div
											tw="overflow-x-auto"
											className="card-container">
											<div tw="inline-flex flex-row flex-nowrap space-x-6 justify-evenly">
												<Link
													to={ROUTES.OURPHOTOS}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#ECF5F8">
														<Image
															preview={false}
															src={camera}
															alt=""
															width={60}
															height={60}
														/>
														<span className="action-title">
															Add prewedding
															photos
														</span>
													</CardBox>
												</Link>
												<Link
													to={ROUTES.OURSTORY}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#FDF2E1">
														<Image
															preview={false}
															src={diary}
															alt=""
															width={75}
															height={60}
														/>
														<span className="action-title">
															Tell your story; How
															you met your spouse
														</span>
													</CardBox>
												</Link>
												<Link
													to={ROUTES.INVITEFRIEND}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#FFF1F1">
														<Image
															preview={false}
															src={invitation}
															alt=""
															width={90}
															height={65}
														/>
														<span className="action-title">
															Your wedding
															Invitation
														</span>
													</CardBox>
												</Link>
												<Link
													to={ROUTES.INVITEFRIEND}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#DCDBE9">
														<Image
															preview={false}
															src={calendar}
															alt=""
															width={50}
															height={85}
														/>
														<span className="action-title">
															Send save the date
														</span>
													</CardBox>
												</Link>
												<Link
													to={ROUTES.PLANWEDDING}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#E3E1FF">
														<Image
															preview={false}
															src={gift}
															alt=""
															width={50}
															height={85}
														/>
														<span className="action-title">
															Plan your gift
															registry
														</span>
													</CardBox>
												</Link>
												<Link
													to={ROUTES.VENDORS}
													tw="text-current hover:(text-appPinkSaturated)">
													<CardBox bg="#e1ffe3">
														<Image
															preview={false}
															src={vendor}
															alt=""
															width={50}
															height={60}
														/>
														<span className="action-title">
															Find vendors to
															deploy
														</span>
													</CardBox>
												</Link>
											</div>
										</div>
									</div>
								)}

								{!user?.is_bvn_set && !user?.is_wallet_set && (
									<div tw="mt-2 md:mt-4 ">
										{
											<SetupWallet
												handleWalletSetup={() =>
													history.push(ROUTES.WALLET)
												}
											/>
										}
									</div>
								)}
								{(!isEmpty(upcomingWeddings?.weddings) ||
									experience !== "guest") && (
									<div tw="mt-6 md:mt-8 px-2 py-1  md:(px-6  py-3 )bg-white">
										<span
											className="pre-header"
											tw="text-sm! md:text-base!">
											Time to Wedding
											{
												upcomingWeddings?.weddings
													?.bride_firstname
											}{" "}
											{
												upcomingWeddings?.weddings
													?.groom_firstname
											}
										</span>
										<div tw="flex flex-row flex-wrap md:flex-nowrap items-center justify-between">
											<h2 tw="opacity-80 m-0 font-semibold text-sm md:text-xl">
												{dayjs(wedDate).format(
													"D MMMM YYYY"
												)}
											</h2>
											<span tw="opacity-50 cursor-wait inline-flex text-xs md:text-sm items-center space-x-1">
												<Image
													preview={false}
													src={time}
													alt=""
													width={15}
													height={15}
												/>
												<span>
													{" "}
													{remainingDays > 0
														? `${remainingDays} days left`
														: remainingDays === 0
														? `D-Day  🤗`
														: dayjs(
																couple?.date
														  ).fromNow()}
												</span>
											</span>
										</div>
										<div>
											<Progress
												percent={progressPercent}
												size="small"
												showInfo={false}
												strokeColor={COLORS.appPink}
											/>
										</div>
									</div>
								)}

								{/* Timeline Section  */}
								<HomeTimelineWrapper>
									<div tw="flex flex-row! flex-nowrap items-center justify-between gap-4 pl-6 pr-6">
										<h4 tw="opacity-80 font-semibold text-lg mt-4 mb-2">
											My timeline
										</h4>
										<Link to={ROUTES.TIMELINE}>
											<span tw="flex flex-row flex-nowrap items-center text-appPink opacity-50 cursor-pointer text-xs md:text-sm hover:(text-appPink opacity-100)">
												<span>See All</span>
												<Image
													preview={false}
													src={caret}
													alt=""
													width={10}
													height={10}
												/>
											</span>
										</Link>
									</div>

									<div>
										<TimelineContainer tw="overflow-x-auto overflow-y-hidden gap-4 flex flex-row flex-nowrap">
											{tlLoading ? (
												Array.apply(null, Array(3)).map(
													(i) => {
														return (
															<TimelineSkeleton
																key={v4()}
															/>
														);
													}
												)
											) : isEmpty(timeline?.timeline) ? (
												<div tw="w-full flex items-center justify-center">
													<EmptyData />
												</div>
											) : (
												timeline?.timeline?.map(
													(tl, i) => {
														return (
															<TimelineComp
																key={i}
																likes={
																	tl.likes_count
																}
																comments={
																	tl.comments_count
																}
																imageBg={
																	tl.wedding
																		.story_cover_image_url
																}
																timelineData={
																	tl
																}
																loading={
																	tlLoading
																}
																// refetch={refetchTl}
															/>
														);
													}
												)
											)}
										</TimelineContainer>
									</div>
								</HomeTimelineWrapper>

								{experience === "couple" && (
									<div tw="mt-8 px-1 py-1 md:(px-6 py-3) bg-white">
										<span
											className="pre-header"
											tw="text-sm md:text-base!">
											You have{" "}
											{wedding_invites?.length > 0
												? wedding_invites?.length
												: "0"}{" "}
											guests
										</span>
										<div tw="flex flex-row flex-nowrap items-center justify-between mt-1">
											<h2 tw="opacity-80 font-semibold m-0 text-sm md:text-2xl">
												Your guests
											</h2>
											<Link
												to={`${ROUTES.REGISTRY}/guests`}>
												<span tw="text-appPink opacity-50 cursor-pointer text-xs md:text-sm hover:(text-appPink opacity-100)">
													See All{" "}
													<Image
														preview={false}
														src={caret}
														alt=""
														width={10}
														height={10}
													/>
												</span>
											</Link>
										</div>
										<div tw="flex flex-row flex-wrap md:flex-nowrap items-center justify-between mt-2 gap-3">
											<div
												tw="inline-flex items-center space-x-2 overflow-x-auto"
												className="no-scroll">
												<Avatar.Group
													maxCount={13}
													size="large">
													{invitesLoading ? (
														<Avatar
															src={girl}
															style={{
																backgroundColor:
																	"#D7D7E3",
															}}
															tw="border-2 border-solid border-white p-1 hover:(shadow cursor-pointer rounded-full)"
															size={50}>
															<Loading />{" "}
														</Avatar>
													) : isEmpty(
															wedding_invites
													  ) ? (
														<h4 tw="text-appPink">
															{" "}
															You have no invited
															guests yet
														</h4>
													) : (
														wedding_invites
															?.slice(0, 15)
															.map(
																(
																	invitee,
																	i
																) => {
																	// console.log(
																	// 	"invitee",
																	// 	invitee
																	// );
																	if (
																		invitee.response !==
																		"accepted"
																	) {
																		return (
																			<Avatar
																				key={
																					i
																				}
																				tw="flex justify-center font-bold items-center border-2 border-solid border-white rounded-full p-1 hover:(shadow cursor-pointer)"
																				size={
																					55
																				}>
																				{
																					invitee
																						.firstname[0]
																				}
																				{
																					invitee
																						.lastname[0]
																				}
																			</Avatar>
																		);
																	}
																	return (
																		<Avatar
																			key={
																				i
																			}
																			// style={{
																			// 	backgroundColor:
																			// 		"#D7D7E3",
																			// }}
																			tw="flex bg-appLightPink font-semibold text-appPinkSaturated justify-center items-center border-2 border-solid border-white rounded-full p-1 hover:(shadow cursor-pointer)"
																			size={
																				55
																			}>
																			{
																				invitee
																					.firstname[0]
																			}
																			{
																				invitee
																					.lastname[0]
																			}
																		</Avatar>
																	);
																}
															)
													)}
												</Avatar.Group>
												{wedding_invites?.length >
													14 && (
													<span tw="font-semibold tracking-tight text-xs md:text-sm">
														+{" "}
														{wedding_invites?.length -
															13}{" "}
														people
													</span>
												)}
											</div>
											<Link to={ROUTES.INVITEFRIEND}>
												<button tw="border-none bg-transparent cursor-pointer inline-flex flex-row flex-nowrap opacity-70 hover:(text-appPinkSaturated opacity-100) items-center">
													<span tw="text-appPink text-sm font-semibold mr-1">
														New
													</span>
													<Image
														preview={false}
														alt=""
														src={plus}
														width={25}
														height={25}
													/>
												</button>
											</Link>
										</div>
									</div>
								)}

								{/* Become a vendor */}
								{experience === "guest" && (
									<div
										className="tell-story"
										tw="bg-gray-200! shadow mt-4 mb-8">
										<div tw="flex flex-col flex-nowrap items-center justify-center">
											<div tw="p-2 md:p-4 mt-4">
												<h2 tw="text-center opacity-50 m-0 text-sm md:text-base">
													Become a Vendor
												</h2>
												<p tw="mt-4 text-center opacity-50">
													Earn a extra income by and
													unlock new
													<br /> opportunities by
													providing wedding service
												</p>
												<div tw="flex flex-row items-center justify-center gap-4 w-full flex-wrap p-4">
													{[
														{ title: "Venues" },
														{ title: "Band" },
														{ title: "Food" },
														{
															title: "Dress & Suit",
														},
														{ title: "Cake" },
														{ title: "Photgraphy" },
														{ title: "Planner" },
														{ title: "Decoration" },
													]?.map((cat, i) => {
														return (
															<Button
																type="text"
																key={i}
																// css={isActive && active}
																tw="rounded-2xl min-w-min text-white bg-gray-400 inline-flex gap-2  items-center justify-center py-4 px-5">
																<span tw="text-sm font-semibold">
																	{cat?.title}
																</span>
															</Button>
														);
													})}
												</div>
											</div>
											<VendorAdvertCard
												tw="relative!"
												style={{
													height: "360px",
													backgroundImage: `url(${vendorImg})`,
													width: "100%",
													overflow: "hidden",
													backgroundSize: "cover",
													backgroundPosition:
														"center",
													backgroundRepeat:
														"no-repeat",
													borderRadius:
														"0 0 12px 12px",
												}}>
												<Link to={ROUTES.BECOMEAVENDOR}>
													<Button tw="absolute px-5 py-6 bottom-8 right-8 left-8 bg-appPink text-white text-base font-bold rounded-2xl border-0 flex items-center justify-center hover:(bg-appLightPink text-appPinkSaturated shadow-lg) focus:(border-none )">
														Learn More
													</Button>
												</Link>
											</VendorAdvertCard>
										</div>
									</div>
								)}
							</div>
						</div>

						<PinSetup pinData={pin} />
						<PinInput
							pin={pin}
							title={
								"Keep your account safe, set a PIN for all transactions"
							}
							confirmPinInput
							isVisible={isTransactionPin}
							setPin={setUserPin}
							goBack={() => setTransactionPin(false)}
							continueTask={() => setTransactionPin(false)}
						/>
					</HomeWrapper>
				}
				right={
					<>
						{/* Timeline Section  */}
						<div className="timeline sider" tw="mt-8">
							<div tw="flex flex-row flex-nowrap items-center justify-between mr-4 mb-4">
								<h4 tw="opacity-80 font-semibold text-lg mb-2">
									My timeline
								</h4>
								<Link to={ROUTES.TIMELINE}>
									<span tw="text-appPink opacity-50 cursor-pointer text-xs md:text-sm hover:(text-appPink opacity-100)">
										See All{" "}
										<Image
											preview={false}
											src={caret}
											alt=""
											width={10}
											height={10}
										/>
									</span>
								</Link>
							</div>
							<div tw="mr-4">
								<TimelineContainer tw="overflow-x-hidden overflow-y-auto gap-4 flex flex-col w-full">
									{tlLoading ? (
										Array.apply(null, Array(3)).map((i) => {
											return (
												<TimelineSkeleton key={v4()} />
											);
										})
									) : isEmpty(timeline?.timeline) ? (
										<div tw="w-full flex items-center justify-center">
											<EmptyData />
										</div>
									) : (
										timeline?.timeline?.map((tl, i) => {
											return (
												<TimelineComp
													key={i}
													likes={tl.likes_count}
													comments={tl.comments_count}
													imageBg={
														tl.wedding
															.story_cover_image_url
													}
													timelineData={tl}
													loading={tlLoading}
													refetch={refetchTl}
												/>
											);
										})
									)}
								</TimelineContainer>
							</div>
						</div>
					</>
				}
			/>
		</MainLayout>
	);
};

export default Home;
